module.exports = __webpack_public_path__ + "static/media/1POLICY18.8b9430be.jpg";